import usersIcon from "@assets/icons/settingsCards/users.svg";

export const CARDS = [
  {
    label: "Manage Users",
    icon: usersIcon,
    path: "/settings/manage-users",
  },
];
